import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Support = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M18.5 18.5L14.8659 14.8659M9.1289 9.1289L5.5 5.5M5.5 18.5L9.1289 14.8711M14.8659 9.13412L18.5 5.5M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12ZM16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12Z'
        stroke='currentColor'
        strokeWidth='1.5'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.65634 19.4043C7.36149 20.8666 9.57758 21.75 12 21.75C14.4225 21.75 16.6386 20.8666 18.3437 19.4043L14.7866 15.8471C14.0039 16.4151 13.0411 16.7499 12.0001 16.7499C10.959 16.7499 9.99625 16.4151 9.21352 15.8471L5.65634 19.4043ZM4.59568 18.3437C3.13343 16.6385 2.25 14.4224 2.25 12C2.25 9.57755 3.13345 7.36144 4.59573 5.65628L8.15286 9.2134C7.58494 9.99613 7.25006 10.9589 7.25006 11.9999C7.25006 13.041 7.58494 14.0038 8.15286 14.7865L4.59568 18.3437ZM5.6564 4.59563C7.36155 3.13341 9.57761 2.25 12 2.25C14.4224 2.25 16.6385 3.13343 18.3437 4.59568L14.7866 8.15274C14.0039 7.58483 13.0411 7.24994 12.0001 7.24994C10.959 7.24994 9.99625 7.58483 9.21352 8.15274L5.6564 4.59563ZM19.4043 5.65634C20.8666 7.36149 21.75 9.57758 21.75 12C21.75 14.4224 20.8666 16.6385 19.4044 18.3436L15.8473 14.7865C16.4152 14.0038 16.7501 13.041 16.7501 11.9999C16.7501 10.9589 16.4152 9.99613 15.8473 9.2134L19.4043 5.65634ZM8.75006 11.9999C8.75006 13.7949 10.2051 15.2499 12.0001 15.2499C13.795 15.2499 15.2501 13.7949 15.2501 11.9999C15.2501 10.205 13.795 8.74994 12.0001 8.74994C10.2051 8.74994 8.75006 10.205 8.75006 11.9999Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
